/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.OnlinePresenceManagement {
    'use strict';

    interface IOnlinePresenceManagementController {
        closeContext: () => void;
        generateURL: () => void;
    }

    class OnlinePresenceManagementController implements IOnlinePresenceManagementController {
        static $inject = [
            '$rootScope',
            '$state',
            '$sce',
            'meevo.components.common.YextService'
        ];

        public yextModelURL: string;

        constructor(
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected $sce: ng.ISCEService,

            private yextService: Meevo.Components.Common.YextService,
        ) {
            this.generateURL();
        }

        public isIOSDevice = /iPad|iPhone/.test(navigator.platform) || ((navigator.userAgent.includes("Mac") && "ontouchend" in document));
        public isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);s

        // Close current tab
        public closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        // Generate Yext URL
        public generateURL(): void {
            if (!this.isIOSDevice) {
                this.yextService.getURL('reviewsResponse').then(() => {
                    if (this.yextService.isLocationOnboarded) {
                        this.yextModelURL = this.$sce.trustAsResourceUrl(this.yextService.url);
                        if (this.isSafari) {
                            window.open(this.yextModelURL, "_blank");
                            this.closeContext();
                        }
                    } else {
                        this.yextService.showWarningLocationNotOnboarded();
                    }
                });
            }
        }

    }

    angular.module('meevo.plugins.onlinePresenceManagement')
        .controller('meevo.plugins.onlinePresenceManagement.OnlinePresenceManagementController', OnlinePresenceManagementController);
}
